import qs from 'qs';

const updateUrlState = (sku) => {
  if(!window.history.replaceState) {
    return;
  }

  let parts = window.location.pathname.split('/').filter(part => part);

  if(parts.length === 3) {
    parts.pop();
  }

  parts.push(sku);

  window.history.replaceState(null, '', '/' + parts.join('/'));
};

// point of truth
const state = () => ({
  imageScene: '',
  pageItemClass: '',
  selectedVariant: {},
  variants: [],
});

// accessors
const getters = {
  activeImageScene: (state) => {
    return state.imageScene;
  },

  activeVariant: (state) => {
    return state.selectedVariant;
  },

  activeVariantThumbs: (state) => {
    return state.selectedVariant.thumbs;
  },

  allVariants: (state) => {
    return state.variants;
  },

  activeVariants: (state) => {
    return state.variants.filter(variant => !variant.discontinued);
  },

  discontinuedVariants: (state) => {
    return state.variants.filter(variant => variant.discontinued);
  },

  specificationsPath: (state) => {
    return `/item/${state.selectedVariant.sku}/specs${state.imageScene ? `?scene=${state.imageScene}` : ''}`;
  },

  variantWithSku: (state) => (sku) => {
    return state
      .variants
      .find(variant => variant.sku === sku);
  },
};

// update state
const mutations = {
  updateImageScene(state, scene) {
    state.imageScene = scene;
  },

  updateActiveVariant(state, variant) {
    state.selectedVariant = variant;
  },

  updatePageItemClass(state, itemClass) {
    state.pageItemClass = itemClass;
  },

  updateVariants(state, variants) {
    state.variants = variants;
  },
};

// commit mutations
const actions = {
  setImageScene({ commit }, scene) {
    commit('updateImageScene', scene);
  },

  setActiveVariant({ commit, getters, state }, { sku, ignoreUrl = false }) {
    let variant = getters.variantWithSku(sku);

    if(!variant) {
      return;
    }

    // variant belongs to a linked product, hand off to its own detail page
    if(state.pageItemClass && variant.item_class !== state.pageItemClass) {
      window.location.assign(variant.url);

      return;
    }

    if(!ignoreUrl) {
      updateUrlState(variant.sku);
    }

    commit('updateActiveVariant', variant);
  },

  setPageItemClass({ commit }, itemClass) {
    commit('updatePageItemClass', itemClass);
  },

  setVariants({ commit }, variants) {
    commit('updateVariants', variants);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
